import { Avatar, styled } from "@mui/material";
import { deepOrange } from "@mui/material/colors";
import { Link } from "react-router-dom";

import { offBlack, offGrey, darkGrey } from "@/theme/colors";
import { dontForwardProps } from "@/lib/styled";

import { AvatarCardType } from "./avatar-card";

export const AvatarCard = styled(Link)(
  ({ theme }) => `
  border-radius: var(--border-radius-2x);
  border: 1px solid ${offGrey};
  background: white;
  box-shadow: var(--shadow-2x);
  color: ${darkGrey};
  display: flex;
  flex: 1 1 0;
  outline: none;
  padding: clamp(var(--spacing-3x), 2vw, ${theme.spacing(2)});
  text-decoration: none;
  transition: border-color .2s ease;

  &:hover,
  &:visited {
    color: ${darkGrey};
  }

  &:hover,
  &:focus {
    border-color: var(--blue);
  }

  [data-theme='dark'] & {
    border-color: color-mix(in srgb, var(--blue) 60%, black);
    background: var(--blue);
    color: white;

    &:visited,
    &:hover {
      color: white;
    }

    &:hover,
    &:focus {
      border-color: var(--white);
    }
  }

  @media (width >= 640px) {
    padding: ${theme.spacing(3)};
  }
`,
);

export const AvatarCardLogo = styled(Avatar, {
  shouldForwardProp: dontForwardProps("type"),
})<{ type: AvatarCardType }>(({ theme, type }) => {
  let logoColor = "var(--blue)";
  if (type === AvatarCardType.ORGANISATION) logoColor = deepOrange[500];

  return `
      align-items: center;
      background-color: ${logoColor};
      border-radius: 50%;
      color: white;
      display: flex;
      font-weight: 700;
      height: 56px;
      justify-content: center;
      text-transform: uppercase;
      margin-right: ${theme.spacing(1)};
      min-width: 56px;
      min-height: 56px;
      width: 56px;

      [data-theme='dark'] & {
        ${
          logoColor === "var(--blue)" &&
          `
          background-color: ${theme.palette.primary.light};
          color: ${logoColor};
        `
        }
      }
  `;
});

export const AvatarCardTag = styled("span")(
  ({ theme }) => `
  border-radius: 30px;
  background: ${theme.palette.primary.light};
  padding: 6px 12px;
  color: ${offBlack};
  font-size: 14px;
`,
);

export const AvatarCardTitle = styled("h3")(`
  align-items: center;
  display: flex;
  line-height: 1.2em;
  margin: 0;
  min-height: 58px;
`);

export const AvatarCardLabel = styled("div")(
  ({ theme }) => `
  color: color-mix(in srgb, var(--foreground) 50%, transparent);
  font-size: 12px;
  line-height: 16px;
  margin: ${theme.spacing(1)} 0 -${theme.spacing(1)};

  @media (width >= 640px) {
    margin: ${theme.spacing(2)} 0 -${theme.spacing(1)};
  }
`,
);
